import { render, staticRenderFns } from "./SimulatorHeader.vue?vue&type=template&id=36415cc8&"
import script from "./SimulatorHeader.vue?vue&type=script&lang=ts&"
export * from "./SimulatorHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports